module.exports = __webpack_public_path__ + "static/media/NE_resume.29cc19f0.pdf";